/**
* DevExpress Analytics (core\internal\_papperKindMapper.js)
* Version:  23.1.7
* Build date: Dec 11, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { roundingXDecimals } from '../utils/_units';
var papperKindMapper = {
    A2: { width: 4200, height: 5940, unit: 'TenthsOfAMillimeter' },
    A3: { width: 2970, height: 4200, unit: 'TenthsOfAMillimeter' },
    A3Extra: { width: 3220, height: 4450, unit: 'TenthsOfAMillimeter' },
    A3ExtraTransverse: { width: 3220, height: 4450, unit: 'TenthsOfAMillimeter' },
    A3Rotated: { width: 4200, height: 2970, unit: 'TenthsOfAMillimeter' },
    A3Transverse: { width: 2970, height: 4200, unit: 'TenthsOfAMillimeter' },
    A4: { width: 2100, height: 2970, unit: 'TenthsOfAMillimeter' },
    A4Extra: { width: 2360, height: 3220, unit: 'TenthsOfAMillimeter' },
    A4Plus: { width: 2100, height: 3300, unit: 'TenthsOfAMillimeter' },
    A4Rotated: { width: 2970, height: 2100, unit: 'TenthsOfAMillimeter' },
    A4Small: { width: 2100, height: 2970, unit: 'TenthsOfAMillimeter' },
    A4Transverse: { width: 2100, height: 2970, unit: 'TenthsOfAMillimeter' },
    A5: { width: 1480, height: 2100, unit: 'TenthsOfAMillimeter' },
    A5Extra: { width: 1740, height: 2350, unit: 'TenthsOfAMillimeter' },
    A5Rotated: { width: 2100, height: 1480, unit: 'TenthsOfAMillimeter' },
    A5Transverse: { width: 1480, height: 2100, unit: 'TenthsOfAMillimeter' },
    A6: { width: 1050, height: 1480, unit: 'TenthsOfAMillimeter' },
    A6Rotated: { width: 1480, height: 1050, unit: 'TenthsOfAMillimeter' },
    APlus: { width: 2270, height: 3560, unit: 'TenthsOfAMillimeter' },
    B4: { width: 2500, height: 3530, unit: 'TenthsOfAMillimeter' },
    B4Envelope: { width: 2500, height: 3530, unit: 'TenthsOfAMillimeter' },
    B4JisRotated: { width: 3640, height: 2570, unit: 'TenthsOfAMillimeter' },
    B5: { width: 1760, height: 2500, unit: 'TenthsOfAMillimeter' },
    B5Envelope: { width: 1760, height: 2500, unit: 'TenthsOfAMillimeter' },
    B5Extra: { width: 2010, height: 2760, unit: 'TenthsOfAMillimeter' },
    B5JisRotated: { width: 2570, height: 1820, unit: 'TenthsOfAMillimeter' },
    B5Transverse: { width: 1820, height: 2570, unit: 'TenthsOfAMillimeter' },
    B6Envelope: { width: 1760, height: 1250, unit: 'TenthsOfAMillimeter' },
    B6Jis: { width: 1280, height: 1820, unit: 'TenthsOfAMillimeter' },
    B6JisRotated: { width: 1820, height: 1280, unit: 'TenthsOfAMillimeter' },
    BPlus: { width: 3050, height: 4870, unit: 'TenthsOfAMillimeter' },
    C3Envelope: { width: 3240, height: 4580, unit: 'TenthsOfAMillimeter' },
    C4Envelope: { width: 2290, height: 3240, unit: 'TenthsOfAMillimeter' },
    C5Envelope: { width: 1620, height: 2290, unit: 'TenthsOfAMillimeter' },
    C65Envelope: { width: 1140, height: 2290, unit: 'TenthsOfAMillimeter' },
    C6Envelope: { width: 1140, height: 1620, unit: 'TenthsOfAMillimeter' },
    CSheet: { width: 1700, height: 2200, unit: 'HundredthsOfAnInch' },
    DLEnvelope: { width: 1100, height: 2200, unit: 'TenthsOfAMillimeter' },
    DSheet: { width: 2200, height: 3400, unit: 'HundredthsOfAnInch' },
    ESheet: { width: 3400, height: 4400, unit: 'HundredthsOfAnInch' },
    Executive: { width: 725, height: 1050, unit: 'HundredthsOfAnInch' },
    Folio: { width: 850, height: 1300, unit: 'HundredthsOfAnInch' },
    GermanLegalFanfold: { width: 850, height: 1300, unit: 'HundredthsOfAnInch' },
    GermanStandardFanfold: { width: 850, height: 1200, unit: 'HundredthsOfAnInch' },
    InviteEnvelope: { width: 2200, height: 2200, unit: 'TenthsOfAMillimeter' },
    IsoB4: { width: 2500, height: 3530, unit: 'TenthsOfAMillimeter' },
    ItalyEnvelope: { width: 1100, height: 2300, unit: 'TenthsOfAMillimeter' },
    JapaneseDoublePostcard: { width: 2000, height: 1480, unit: 'TenthsOfAMillimeter' },
    JapaneseDoublePostcardRotated: { width: 1480, height: 2000, unit: 'TenthsOfAMillimeter' },
    JapanesePostcard: { width: 1000, height: 1480, unit: 'TenthsOfAMillimeter' },
    Ledger: { width: 1700, height: 1100, unit: 'HundredthsOfAnInch' },
    Legal: { width: 850, height: 1400, unit: 'HundredthsOfAnInch' },
    LegalExtra: { width: 927.5, height: 1500, unit: 'HundredthsOfAnInch' },
    Letter: { width: 850, height: 1100, unit: 'HundredthsOfAnInch' },
    LetterExtra: { width: 927.5, height: 1200, unit: 'HundredthsOfAnInch' },
    LetterExtraTransverse: { width: 927.5, height: 1200, unit: 'HundredthsOfAnInch' },
    LetterPlus: { width: 850, height: 1269, unit: 'HundredthsOfAnInch' },
    LetterRotated: { width: 1100, height: 850, unit: 'HundredthsOfAnInch' },
    LetterSmall: { width: 850, height: 1100, unit: 'HundredthsOfAnInch' },
    LetterTransverse: { width: 827.5, height: 1100, unit: 'HundredthsOfAnInch' },
    MonarchEnvelope: { width: 387.5, height: 750, unit: 'HundredthsOfAnInch' },
    Note: { width: 850, height: 1100, unit: 'HundredthsOfAnInch' },
    Number10Envelope: { width: 412.5, height: 950, unit: 'HundredthsOfAnInch' },
    Number11Envelope: { width: 450, height: 1037.5, unit: 'HundredthsOfAnInch' },
    Number12Envelope: { width: 475, height: 1100, unit: 'HundredthsOfAnInch' },
    Number14Envelope: { width: 500, height: 1150, unit: 'HundredthsOfAnInch' },
    Number9Envelope: { width: 387.5, height: 887.5, unit: 'HundredthsOfAnInch' },
    PersonalEnvelope: { width: 362.5, height: 650, unit: 'HundredthsOfAnInch' },
    Prc16K: { width: 1460, height: 2150, unit: 'TenthsOfAMillimeter' },
    Prc16KRotated: { width: 1460, height: 2150, unit: 'TenthsOfAMillimeter' },
    Prc32K: { width: 970, height: 1510, unit: 'TenthsOfAMillimeter' },
    Prc32KBig: { width: 970, height: 1510, unit: 'TenthsOfAMillimeter' },
    Prc32KBigRotated: { width: 970, height: 1510, unit: 'TenthsOfAMillimeter' },
    Prc32KRotated: { width: 970, height: 1510, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber1: { width: 1020, height: 1650, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber10: { width: 3240, height: 4580, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber10Rotated: { width: 4580, height: 3240, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber1Rotated: { width: 1650, height: 1020, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber2: { width: 1020, height: 1760, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber2Rotated: { width: 1760, height: 1020, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber3: { width: 1250, height: 1760, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber3Rotated: { width: 1760, height: 1250, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber4: { width: 1100, height: 2080, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber4Rotated: { width: 2080, height: 1100, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber5: { width: 1100, height: 2200, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber5Rotated: { width: 2200, height: 1100, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber6: { width: 1200, height: 2300, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber6Rotated: { width: 2300, height: 1200, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber7: { width: 1600, height: 2300, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber7Rotated: { width: 2300, height: 1600, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber8: { width: 1200, height: 3090, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber8Rotated: { width: 3090, height: 1200, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber9: { width: 2290, height: 3240, unit: 'TenthsOfAMillimeter' },
    PrcEnvelopeNumber9Rotated: { width: 3240, height: 2290, unit: 'TenthsOfAMillimeter' },
    Quarto: { width: 2150, height: 2750, unit: 'TenthsOfAMillimeter' },
    Standard10x11: { width: 1000, height: 1100, unit: 'HundredthsOfAnInch' },
    Standard10x14: { width: 1000, height: 1400, unit: 'HundredthsOfAnInch' },
    Standard11x17: { width: 1100, height: 1700, unit: 'HundredthsOfAnInch' },
    Standard12x11: { width: 1200, height: 1100, unit: 'HundredthsOfAnInch' },
    Standard15x11: { width: 1500, height: 1100, unit: 'HundredthsOfAnInch' },
    Standard9x11: { width: 900, height: 1100, unit: 'HundredthsOfAnInch' },
    Statement: { width: 550, height: 850, unit: 'HundredthsOfAnInch' },
    Tabloid: { width: 1100, height: 1700, unit: 'HundredthsOfAnInch' },
    TabloidExtra: { width: 1169, height: 1800, unit: 'HundredthsOfAnInch' },
    USStandardFanfold: { width: 1487.5, height: 1100, unit: 'HundredthsOfAnInch' }
};
function calculateDimension(dimension, unit, precision) {
    var result = unit === 'HundredthsOfAnInch' ? dimension : dimension / 2.54;
    if (precision !== undefined) {
        return roundingXDecimals(result, false, precision);
    }
    return result;
}
export function getPaperSize(kind, precision) {
    var size = papperKindMapper[kind];
    return {
        width: calculateDimension(size.width, size.unit, precision),
        height: calculateDimension(size.height, size.unit, precision),
    };
}
